import AwardBadgeButton from './AwardBadgeButton';
import AwardBadgeButtonContainer from './AwardBadgeButton.container';
export default AwardBadgeButtonContainer(AwardBadgeButton);

//# sourceMappingURL=index.js.map